import { Box, Tooltip, Typography } from "@mui/material";
import { BarChart } from "@mui/x-charts";
import useColors from "../../../../../../../api/hooks/useColors";
import { filterName } from "../../../../filters/utils";

const CustomCveBarChart = ({
  series,
  labels,
  appliedFilters,
  setAppliedFilters,
}) => {
  const colors = useColors();
  const renderTooltip = (value, event) => {
    const barIndex = value.itemData.dataIndex;

    const count = value.series.data[barIndex];

    return (
      <Box
        sx={{
          height: "22px",
          padding: "10px",
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          top: "-30px",
          left: "-30px",
          backgroundColor: colors.common_white,
          boxShadow: "0px 1px 2px " + colors.black_24percent,
          "&::after": {
            content: '""',
            position: "absolute",
            width: 0,
            height: 0,
            borderLeft: "6px solid transparent",
            borderRight: "6px solid transparent",
            borderTop: `6px solid ${colors.common_white}`,
            top: "100%",
            left: "calc(50% - 6px)",
          },
        }}
      >
        <Typography variant="caption"> {count}</Typography>
      </Box>
    );
  };

  const maxCount =
    Math.max(...series.map((item) => Math.max(...item.data))) * 1.1;

  // filter entities by entity_ids
  const onBarClick = (event, clickedBarData) => {
    const groupIndex = clickedBarData.dataIndex;
    const seriesIdList = clickedBarData.seriesId.split("-");
    const seriesId = Number(seriesIdList[seriesIdList.length - 1]);
    const entity_ids = series[seriesId].entity_ids[groupIndex]; // entity_ids of the bar
    const newFilters = entity_ids?.reduce(
      (acc, entity_id) => ({ ...acc, [entity_id]: true }),
      {}
    );
    setAppliedFilters({
      ...appliedFilters,

      [filterName.ENTITY_IDS]: {
        ...appliedFilters[filterName.ENTITY_IDS],
        ...newFilters,
      },
    });
  };

  const CustomBarLabel = (props) => {
    const height = props.style.height.animation.to + "px";
    const width = props.style.width.animation.to + "px";
    const x =
      props.style.x.animation.to +
      parseInt(props.style.width.animation.to) / 2 +
      2 +
      "px"; // 2px is the padding
    const y = props.style.y.animation.to + 4.5 + "px"; // 4.5px is the padding
    return (
      <text
        style={{
          height: height,
          width: width,
          font: "13px sans-serif",
          fill: colors.text_secondary,
          transform: `translate3d(${x},${y}, 0px)`,
        }}
      >
        {props.children}
      </text>
    );
  };
  const CustomTickLabel = ({ value }) => {
    const truncatedLabel =
      value.length > 10 ? value.slice(0, 10) + "..." : value;
    return (
      <Tooltip title={value}>
        <text>{truncatedLabel}</text>
      </Tooltip>
    );
  };

  return (
    <BarChart
      sx={{
        zIndex: 2,

        "& .MuiChartsAxis-tick": {
          strokeWidth: 0,
        },
        "& .MuiChartsAxis-left .MuiChartsAxis-line": {
          strokeWidth: 0,
        },
        "& .MuiChartsAxis-bottom .MuiChartsAxis-line": {
          strokeWidth: 0,
        },

        "& .MuiChartsAxisHighlight-root": {
          fill: "none",
        }, // color both axis labels
        "& .MuiChartsAxis-root .MuiChartsAxis-tickLabel": {
          fill: colors.text_secondary,
        },
      }}
      onItemClick={onBarClick}
      barLabel={(item, context) => {
        if (item.value < 0.1) return "0";
        return item.value;
      }}
      slots={{
        barLabel: CustomBarLabel,
      }}
      yAxis={[
        {
          scaleType: "band",
          // take the first two words of the label
          data: labels.map((label) => {
            const parts = label.split(" ");
            return parts.length > 1 ? parts[0] + " " + parts[1] : parts[0];
          }),
          categoryGapRatio: labels.length < 4 ? 0.6 : 0.3,
        },
      ]}
      xAxis={[
        {
          max: maxCount,
        },
      ]}
      tooltip={{
        trigger: "item",
        itemContent: renderTooltip,
      }}
      series={series}
      layout="horizontal"
      height={330}
      margin={{
        top: 0,
        left: 130,
      }}
      borderRadius={5}
      grid={{ vertical: true }}
    />
  );
};

export default CustomCveBarChart;
